import { create } from "zustand";
import { login, register } from "../services/authServices";

function isTokenValid(token) {
  if (!token) return false;
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.exp * 1000 > Date.now();
  } catch {
    return false;
  }
}

const useAuthStore = create((set) => ({
  isAuthenticated: isTokenValid(localStorage.getItem("token")),
  isAdmin: JSON.parse(localStorage.getItem("user"))?.isAdmin || false,
  user: JSON.parse(localStorage.getItem("user")) || null,

  login: async (email, password) => {
    try {
      const { token, user } = await login(email, password);
      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user));
      set({
        isAuthenticated: true,
        user: user,
        isAdmin: user.isAdmin,
      });
    } catch (error) {
      console.error("Помилка входу (store):", error);
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      set({ isAuthenticated: false, user: null, isAdmin: false });
      throw error;
    }
  },

  register: async (email, password) => {
    try {
      const { token, user } = await register(email, password);
      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user));
      set({
        isAuthenticated: true,
        user: user,
        isAdmin: user.isAdmin,
      });
    } catch (error) {
      console.error("Помилка реєстрації (store):", error);
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      set({ isAuthenticated: false, user: null, isAdmin: false });
      throw error;
    }
  },

  logout: () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    set({ isAuthenticated: false, user: null, isAdmin: false });
    window.location.href = "/signin";
  },
}));

export default useAuthStore;
